import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import i18next from "i18next";
import global_ru from './translations/ru/global.json';
import global_en from './translations/en/global.json';
import LanguageDetector from 'i18next-browser-languagedetector';
import { I18nextProvider } from "react-i18next";
import './styles/index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

i18next
  .use(LanguageDetector)
  .init({
    interpolation: { escapeValue: false },
    fallbackLng: 'ru',
    resources: {
      en: {
        global: global_en
      },
      ru: {
        global: global_ru
      }
    },
    detection: {
      order: ['localStorage', 'navigator'],  // Определяет порядок, в котором используются методы детектирования
      caches: ['localStorage']
    }
});

root.render(
  <>
    <BrowserRouter>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </BrowserRouter>
  </>
);
